import React from "react";
import Pricing from "@/components/Pricing";

export default function ApproachPage() {
  return (
    <div className="pt-24" data-testid="page-approach">
      <Pricing />
    </div>
  );
}
